$(document).ready(function(){
  var langCs=$('html').attr('lang')==='cs' || $('body').hasClass('locale-cs');

	// Bootstrap tooltip inicialize
	$('[data-navbarTopExpandToggle=tooltip]').tooltip();



	// Bootstrap popover inicialize
	$('[data-navbarTopExpandToggle=popover]').popover();


	// Bootstrap carousel swipe
	$('.carousel')
    .swipe({
      swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
        if (direction === 'left') $(this).carousel('next');
        if (direction === 'right') $(this).carousel('prev');
      },
      allowPageScroll: 'vertical'
    })
    .on('slid.bs.carousel',function(){
      var id = $(this).attr('id');
      $('[data-target="#'+id+'"]').removeClass('active');
      $('[data-target="#'+id+'"][data-slide-to="'+$(this).find('.active').index()+'"]').addClass('active');
    });


	$('[data-select-navbarTopExpandToggle="collapse"] .nav-link').on('click',function(){
		var id = $(this).parents('.collapse').attr('id');
		var txt = $(this).html();
		$('[data-target="#'+id+'"] .txt').html(txt);
    var elementWithDataTarget=$('[data-target="#'+id+'"]');
		if (elementWithDataTarget.is(':visible')) {
      elementWithDataTarget.click();
			$('html,body').animate({scrollTop: elementWithDataTarget.offset().top-15},100);
		}
	});



	// NUMBER LIST
	$('.number-list').each(function(){
		$(this).children('li').each(function(index) {
			$(this).prepend('<span class="list-number">'+(index+ 1)+'</span>');
		});
	});



  var modalTrigger=null;

	$('*')
    .on('show.bs.modal', function(e){
		  $('html').addClass('modal-on');
      modalTrigger = e.relatedTarget;
      $(modalTrigger).attr('aria-expanded', 'true');
	  })
    .on('hidden.bs.modal', function () {
		  $('html').removeClass('modal-on');
      if (modalTrigger){
        $(modalTrigger).attr('aria-expanded', 'false');
        modalTrigger=null;
      }
	  });


	// WP Gallery
  var galleries = $('.gallery');
	galleries.each(function(){
		$(this).wrap('<div class="wp_gallery"></div>');
		$(this).addClass('owl-carousel');
	});

  var prepareOwlNavAriaLabels=function(event) {
    var owlInstance =$(event.target);
    if (owlInstance.hasClass('owl-aria-initialized')) return;
    owlInstance.find('.owl-nav .owl-prev').attr('aria-label', langCs ? 'Předchozí' : 'Previous' );
    owlInstance.find('.owl-nav .owl-next').attr('aria-label', langCs ? 'Následující' : 'Next' );
    owlInstance.addClass('owl-aria-initialized')
  };

	$('.owl-carousel').owlCarousel({
		nav: true,
		responsive:{
			0:{
				items: 1,
				slideBy: 1,
			},
			350:{
        items: 2,
        slideBy: 2,
			},
			768:{
				items: 3,
				slideBy: 3,
			},
			992:{
				items: 5,
				slideBy: 5,
			}
		},
    onInitialized: prepareOwlNavAriaLabels,
    onResized: prepareOwlNavAriaLabels
	});

	// Fancybox
	$('a[href$=".gif"],a[href$=".jpg"],a[href$=".jpeg"],a[href$=".png"],a[href$=".GIF"],a[href$=".JPG"],a[href$=".JPEG"],a[href$=".PNG"]').each(function(){
    	if (!$(this).hasClass('nofancybox') && !$(this).hasClass('no-fancybox') && !$(this).hasClass('download') && !$(this).attr('data-fancybox')){
    		$(this).attr('data-fancybox','');
		}
	});
  galleries.each(function(){
		id = $(this).attr('id');
		$('a',this).attr('data-fancybox',id);
	});
	$('[data-fancybox]').fancybox({
		title:true,
		buttons : [
			'fullScreen',
			'close'
		]
	});

	// jquery ui datepicker
	$('.datepicker').attr('readonly','').datepicker({
		altFormat: 'yy-mm-dd',
		dateFormat: 'dd. mm. yy',
		changeMonth: true,
		changeYear: true
	});

	(function(factory) {
		if ( typeof define === "function" && define.amd ) {
			define( [ "../widgets/datepicker" ], factory );
		} else {
			factory( jQuery.datepicker );
		}
	}
	(function(datepicker) {
		datepicker.regional.cs = {
		closeText: "Zavřít",
		prevText: "&#x3C;Dříve",
		nextText: "Později&#x3E;",
		currentText: "Nyní",
		monthNames: [ "leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec" ],
		monthNamesShort: [ "led","úno","bře","dub","kvě","čer","čvc","srp","zář","říj","lis","pro" ],
		dayNames: [ "neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota" ],
		dayNamesShort: [ "ne", "po", "út", "st", "čt", "pá", "so" ],
		dayNamesMin: [ "ne","po","út","st","čt","pá","so" ],
		weekHeader: "Týd",
		dateFormat: "dd. mm. yy",
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ""
	};
	if (langCs){
    datepicker.setDefaults( datepicker.regional.cs );
	}
	datepicker.setDefaults({
    yearRange: "c-100:c+10",
    minDate:"-100y",
    changeMonth: true,
    changeYear: true,
    altFormat: 'yy-mm-dd',
    dateFormat: 'dd. mm. yy',
	});
	return datepicker.regional.cs;
	}));

  $('.datepicker.history').datepicker("option",{
    yearRange: "c-100:c+0",
    minDate:"-100y",
    maxDate:"+0d"
  });

  if (!Modernizr.inputtypes.date){
    $('input[type="date"]').each(function(){
      $(this).addClass('datepicker');
      $(this).removeAttr('min');
      $(this).removeAttr('max');
      $(this).removeAttr('range');
      $(this).attr('type','text');
      $(this).datepicker();
    })
  }

  $('svg:not([viewBox])').each(function(){
    var svg=$(this);
    var viewBoxX=svg.attr('x');
    viewBoxX=(typeof viewBoxX !== typeof undefined && viewBoxX !== false)?parseFloat(viewBoxX):0;
    var viewBoxY=svg.attr('y');
    viewBoxY=(typeof viewBoxY !== typeof undefined && viewBoxY !== false)?parseFloat(viewBoxY):0;
    var viewBoxWidth=svg.attr('width');
    viewBoxWidth=(typeof viewBoxWidth !== typeof undefined && viewBoxWidth !== false)?parseFloat(viewBoxWidth):0;
    var viewBoxHeight=svg.attr('height');
    viewBoxHeight=(typeof viewBoxHeight !== typeof undefined && viewBoxHeight !== false)?parseFloat(viewBoxHeight):0;

    if (viewBoxHeight>0 && viewBoxWidth>0){
      svg.attr('viewBox',viewBoxX+' '+viewBoxY+' '+viewBoxWidth+' '+viewBoxHeight);
    }
  })

  // prevent colse megamenu if click inside
  // prevent colse modal-mainmenu if click inside
  $(document).on('click', '.nav-main .dropdown-menu, .modal-mainmenu .dropdown-menu', function (e) {
    e.stopPropagation();
  });

  //main menu - in-page navigation
  $('.navbar-main .nav-item.dropdown .dropdown-menu a').click(function(){
    var navLink=$(this).closest('.nav-item.dropdown').children('.nav-link');
    navLink.dropdown('hide');
    navLink.attr('aria-expanded','false');
  })

  $('.modal-mainmenu a:not([data-toggle="dropdown"])').click(function(){
    $(this).closest('.modal-mainmenu').modal('hide');
  })


  //navbar-top
  $('.navbar-top').each(function() {
    var navbarTop = $(this);
    var navTopContainer = navbarTop.find('.nav-top-container');
    var navTop = navTopContainer.find('.nav.nav-top');
    var navbarTopExpandToggle = navTopContainer.find('.navbar-top-expand-toggle');

    // výchozí nastavení z data atributů
    var labelCollapsed = navbarTopExpandToggle.attr('title');
    var labelExpanded = navbarTopExpandToggle.data('title-expanded');

    // timer pro kontrolu overflow po změně velikosti okna
    var checkOverflowTimer;
    function setOverflowTimer(){
      clearTimeout(checkOverflowTimer);
      checkOverflowTimer = setTimeout(checkOverflow, 200);
    }

    function checkOverflow() {
      // odstraníme předchozí označení
      navbarTopExpandToggle.removeClass('d-none');

      var availableWidth = navTopContainer.innerWidth();//// - navbarTopExpandToggle.outerWidth(true);
      if (availableWidth < 100) {
        // obsah ještě není správně vykreslen - doplníme zpoždění kontroly
        setOverflowTimer();
        return;
      }
      var totalWidth = 0;
      var hasOverflow = false;
      // kontrola šířky samotných položek
      var navItems = navTop.find('.nav-item');

      navItems.each(function() {
        var item = $(this);
        totalWidth += item.outerWidth(true);
        if (totalWidth > availableWidth) {
          hasOverflow = true;
        }
      });

      if (hasOverflow) {
        //přetékající obsah
        totalWidth = 0;
        availableWidth = navTopContainer.innerWidth() - navbarTopExpandToggle.outerWidth(true);
        navItems.each(function() {
          var item = $(this);
          totalWidth += item.outerWidth(true);

          if (totalWidth > availableWidth) {
            item.addClass('overflowed');
          }else{
            item.removeClass('overflowed');
          }
        });
        navbarTopExpandToggle.removeClass('d-none');
      }else{
        navbarTopExpandToggle.addClass('d-none');
      }
    }

    // přepínání rozbalení
    navbarTopExpandToggle.on('click', function(e) {
      e.preventDefault();
      if (navbarTop.hasClass('expanded')) {
        navbarTopExpandToggle.attr({
          'aria-expanded': 'false',
          'aria-label': labelCollapsed,
          'title': labelCollapsed
        });
        navbarTop.removeClass('expanded');
        checkOverflow()
      }else{
        navbarTopExpandToggle.attr({
          'aria-expanded': 'true',
          'aria-label': labelExpanded,
          'title': labelExpanded
        });
        navbarTop.addClass('expanded');
        navTop.find('.nav-item').removeClass('overflowed');
      }
    });

    // kontrola resize s debouncing
    $(window).on('resize', function() {
      setOverflowTimer();
    });

    // první kontrola při načtení
    setOverflowTimer();
  });


});